/* ws-video-embed
   DSGVO-konformes Klick-zum-Laden für YouTube- und Vimeo-Videos in den
   SEO-Inhaltsblöcken (sections/ws-collection-seo-text.liquid).
   (MP4-Videos rendert die Section direkt als natives <video> ohne dieses JS.)

   Vor dem Klick wird KEINE Verbindung zum Anbieter aufgebaut — kein iframe,
   kein Thumbnail. Erst der Klick auf den Platzhalter-Button injiziert das
   iframe über die datensparsame Domain www.youtube-nocookie.com bzw.
   player.vimeo.com mit dnt=1 (Do-Not-Track).

   Event-Delegation auf document: funktioniert auch für Inhalte, die per
   Section Rendering API nachgeladen werden. */
(function () {
  'use strict';
  if (window.__wsVideoEmbedInit) return;
  window.__wsVideoEmbedInit = true;

  /* Video-ID robust aus allen gängigen YouTube-URL-Formen ziehen:
     watch?v=…, youtu.be/…, /embed/…, /shorts/…, /live/…, /v/… */
  function parseYouTubeId(url) {
    if (!url) return null;
    var s = String(url).trim();
    var m = s.match(/(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/|live\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if (m) return m[1];
    m = s.match(/[?&]v=([A-Za-z0-9_-]{11})/);
    return m ? m[1] : null;
  }

  /* Vimeo-ID aus den gängigen URL-Formen ziehen:
     vimeo.com/123456789, player.vimeo.com/video/123456789,
     vimeo.com/channels/xyz/123456789, vimeo.com/groups/xyz/videos/123456789 */
  function parseVimeoId(url) {
    if (!url) return null;
    var s = String(url).trim();
    var m = s.match(/vimeo\.com\/(?:video\/|channels\/[^\/]+\/|groups\/[^\/]+\/videos\/)?(\d+)(?:$|[?#\/])/);
    return m ? m[1] : null;
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('.ws-seo-text__video-btn') : null;
    if (!btn) return;
    var wrap = btn.closest('.ws-seo-text__video');
    if (!wrap || wrap.classList.contains('ws-seo-text__video--loaded')) return;

    /* Anbieter erkennen: erst YouTube (unverändertes Muster), dann Vimeo.
       Unbekannte URL: Platzhalter ausblenden statt eine tote Fläche zu zeigen. */
    var url = wrap.getAttribute('data-ws-video-url');
    var src = null;
    var title = null;
    var allow = null;

    var ytId = parseYouTubeId(url);
    if (ytId) {
      src = 'https://www.youtube-nocookie.com/embed/' + ytId + '?autoplay=1&rel=0';
      title = 'YouTube-Video';
      allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    } else {
      var vimeoId = parseVimeoId(url);
      if (vimeoId) {
        /* dnt=1 = Do-Not-Track: Vimeo darf keine Tracking-Cookies setzen */
        src = 'https://player.vimeo.com/video/' + vimeoId + '?dnt=1&autoplay=1';
        title = 'Vimeo-Video';
        allow = 'autoplay; fullscreen; picture-in-picture; clipboard-write';
      }
    }

    if (!src) {
      wrap.hidden = true;
      return;
    }

    var iframe = document.createElement('iframe');
    iframe.className = 'ws-seo-text__video-iframe';
    iframe.src = src;
    iframe.title = title;
    iframe.setAttribute('allow', allow);
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');

    wrap.classList.add('ws-seo-text__video--loaded');
    wrap.textContent = '';
    wrap.appendChild(iframe);
    iframe.focus();
  });
})();
